"use client"

import { Bar, BarChart, ResponsiveContainer, XAxis, YAxis, Tooltip, Cell } from "recharts"

const data = [
  {
    name: "Visited Site",
    value: 10000,
    fill: "#e0e0e0",
  },
  {
    name: "Used AI Feature",
    value: 4500,
    fill: "#c5b3e6",
  },
  {
    name: "Viewed Product",
    value: 3200,
    fill: "#9d4edd",
  },
  {
    name: "Added to Cart",
    value: 1800,
    fill: "#ff4d8c",
  },
  {
    name: "Purchased",
    value: 850,
    fill: "#ff0066",
  },
]

export function AnalyticsConversion() {
  return (
    <div className="h-[300px] w-full">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} layout="vertical">
          <XAxis type="number" />
          <YAxis dataKey="name" type="category" width={120} />
          <Tooltip formatter={(value) => [`${value} users`, "Count"]} labelFormatter={() => ""} />
          <Bar dataKey="value" radius={[0, 4, 4, 0]}>
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.fill} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  )
}
